import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import { getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import Contact from '@/sections/forJournalists/Contact';
import PressReleases from '@/sections/forJournalists/PressReleases';
import Downloads from '@/sections/forJournalists/Downloads';
import { FaqIntro } from '@/sections/FaqIntro';
import MoreInfo from '@/sections/MoreInfo';
import { LINKS } from '@/constants/links';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconUserGroup from '@/assets/icons/heroIcons/User-group.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import { useGetNewestPressReleasesQuery } from '@/api/sanity/generated';
import { mapPressReleasesToArticles } from '@/sections/pressReleases/mapPressReleasesToArticles';
import { ArticleBoxProps } from '@/components/boxes';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import React from 'react';
import { SeoHeader } from '@/components/SeoHeader';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { sanityLanguage } from '@/constants/language';
interface Props {
  pageBanner: PageBanner | null;
  pressReleasesArticles: ArticleBoxProps[];
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(55);
  const {
    pageBanner,
    pressReleasesArticles,
    menuPromoBanners
  } = t0;
  usePageView("for-journalists");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core", "forJournalists"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t2;
  if ($[1] !== t) {
    t2 = t("forJournalists:seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("forJournalists:seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[8] !== pageBanner?.title || $[9] !== t) {
    t6 = pageBanner?.title ?? t("forJournalists:heroSection.title");
    $[8] = pageBanner?.title;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== pageBanner?.text || $[12] !== t) {
    t7 = pageBanner?.text ?? <Trans t={t} i18nKey="forJournalists:heroSection.paragraph"><br /></Trans>;
    $[11] = pageBanner?.text;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== pageBanner) {
    t8 = pageBanner ? pageBanner.buttons : [];
    $[14] = pageBanner;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = pageBanner?.image?.url ?? "/images/sections/forJournalists/hero/cs/hero.png";
  let t10;
  if ($[16] !== pageBanner?.image?.alt || $[17] !== t) {
    t10 = pageBanner?.image?.alt ?? t("forJournalists:heroSection.title");
    $[16] = pageBanner?.image?.alt;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = {
      url: t9,
      alt: t10
    };
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = pageBanner?.variant || "mockupMobile";
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t13 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} image={t11} variant={t12} />;
    $[22] = t11;
    $[23] = t12;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    t15 = <Contact />;
    $[29] = t14;
    $[30] = t15;
  } else {
    t14 = $[29];
    t15 = $[30];
  }
  let t16;
  if ($[31] !== isCsLanguage || $[32] !== pressReleasesArticles) {
    t16 = isCsLanguage && pressReleasesArticles.length > 0 && <PressReleases pressReleasesArticles={pressReleasesArticles} />;
    $[31] = isCsLanguage;
    $[32] = pressReleasesArticles;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Downloads />;
    t18 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[34] = t17;
    $[35] = t18;
  } else {
    t17 = $[34];
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t) {
    t19 = t("forJournalists:faqIntro.text");
    $[36] = t;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <FaqIntro text={t19} />;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== isCsLanguage || $[41] !== t) {
    t21 = <MoreInfo buttons={isCsLanguage ? [{
      analyticsParam: "forJournalistsMoreInfoDeferredPayment",
      icon: <IconDeferredPayment className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoDeferredPayment",
      title: t("core:link.deferredPayment"),
      to: LINKS().deferredPayment
    }, {
      analyticsParam: "forJournalistsMoreInfoRevolvingApplication",
      icon: <IconMaxi className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoRevolvingApplication",
      title: t("core:products.revolving"),
      to: LINKS().revolving
    }, {
      analyticsParam: "forJournalistsMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "forJournalistsMoreInfoAboutUs",
      icon: <IconUserGroup className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoAboutUs",
      title: t("core:products.aboutUs"),
      to: LINKS().aboutCompany
    }] : [{
      analyticsParam: "forJournalistsMoreInfoPayInThree",
      icon: <IconThird className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoPayInThree",
      title: t("core:products.payInThree"),
      to: LINKS().payInThree
    }, {
      analyticsParam: "forJournalistsMoreInfoWhereToShop",
      icon: <IconShoppingCart className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoWhereToShop",
      title: t("core:products.whereToShop"),
      to: LINKS().whereToShop
    }, {
      analyticsParam: "forJournalistsMobileApp",
      icon: <IconMobile className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoMobileApp",
      title: t("core:products.mobileApp"),
      to: LINKS().mobileApp
    }, {
      analyticsParam: "forJournalistsMoreInfoAboutCompany",
      icon: <IconUser className="fillButtonIcon" />,
      testId: "forJournalistsMoreInfoAboutCompany",
      title: t("core:link.aboutUs"),
      to: LINKS().aboutCompany
    }]} />;
    $[40] = isCsLanguage;
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t20 || $[44] !== t21) {
    t22 = <div className="relative z-10">{t20}{t21}</div>;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t22) {
    t24 = <div className="relative overflow-hidden bg-blue-50 pt-10 lg:pt-28">{t22}{t23}</div>;
    $[47] = t22;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== menuPromoBanners || $[50] !== t13 || $[51] !== t16 || $[52] !== t24 || $[53] !== t4) {
    t25 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t13}{t14}{t15}{t16}{t17}{t18}{t24}</Layout>;
    $[49] = menuPromoBanners;
    $[50] = t13;
    $[51] = t16;
    $[52] = t24;
    $[53] = t4;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  return t25;
}
export const getStaticProps: GetStaticProps = (async ctx => {
  const fetchPressReleases = useGetNewestPressReleasesQuery.fetcher({
    limit: 3,
    i18nLang: sanityLanguage
  });
  const pressReleasesData = await fetchPressReleases();
  const pressReleasesArticles = pressReleasesData.allPressRelease && pressReleasesData.allPressRelease?.length > 0 && mapPressReleasesToArticles(pressReleasesData.allPressRelease.map(item => ({
    ...item,
    name: item?.name || '',
    slug: {
      current: item?.slug?.current || ''
    }
  }))).filter(Boolean) || [];
  const intlProps = await getIntlProps(ctx, ['core', 'forJournalists']);
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      pageBanner: await getPageBannerBySlug('for-journalists'),
      pressReleasesArticles,
      ...intlProps
    }
  };
}) satisfies GetStaticProps<Props>;